<ng-container *ngIf="mainObject?.Addresses; else addressOnObject">
  <apex-formatted-address [address]="mainObject.Addresses | firstVisitationAddress"></apex-formatted-address>
</ng-container>

<ng-template #addressOnObject> {{ mainObject.address }}, {{ mainObject.zip }} {{ mainObject.postal }} </ng-template>
